import { useState } from "react";
import axios from "axios";
import { useApp, API } from "@/App";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

export const DisclaimerGate = ({ children }) => {
  const { t } = useApp();
  const [accepted, setAccepted] = useState(() => localStorage.getItem("disclaimer_accepted") === "1");
  const [checks, setChecks] = useState([false, false, false, false]);
  const [busy, setBusy] = useState(false);
  const allChecked = checks.every(Boolean);

  if (accepted) return children;

  const toggle = (i) => setChecks((c) => c.map((v, idx) => (idx === i ? !v : v)));

  const accept = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/disclaimer/accept`);
    } catch {
      // logging must not block access
    }
    localStorage.setItem("disclaimer_accepted", "1");
    setAccepted(true);
  };

  return (
    <div data-testid="disclaimer-gate" className="fixed inset-0 z-[100] overflow-y-auto bg-background/80 backdrop-blur-md flex items-start sm:items-center justify-center p-4">
      <div className="w-full max-w-2xl my-6 rounded-2xl border border-border bg-card shadow-xl p-6 sm:p-8 space-y-6">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
            <ShieldAlert className="h-5 w-5" />
          </div>
          <div>
            <h2 className="font-heading text-lg font-bold">{t.disclaimer.title}</h2>
            <p className="text-xs text-muted-foreground">{t.disclaimer.intro}</p>
          </div>
        </div>

        <div className="space-y-4">
          {t.disclaimer.items.map((item, i) => (
            <div key={i} className="rounded-xl border border-border bg-muted/30 p-4 space-y-3">
              <p className="text-sm leading-relaxed whitespace-pre-line">{item}</p>
              <div data-testid={`disclaimer-check-${i + 1}`} className="flex items-center gap-2.5 select-none">
                <Checkbox id={`disclaimer-cb-${i}`} checked={checks[i]} onCheckedChange={() => toggle(i)} data-testid={`disclaimer-checkbox-${i + 1}`} />
                <label htmlFor={`disclaimer-cb-${i}`} className="text-sm font-bold cursor-pointer">{t.disclaimer.yes}</label>
              </div>
            </div>
          ))}
        </div>

        <div className="space-y-2">
          <Button
            data-testid="disclaimer-accept-btn"
            className="w-full h-11 text-base font-semibold"
            disabled={!allChecked || busy}
            onClick={accept}
          >
            {t.disclaimer.accept}
          </Button>
          <p className="text-[11px] text-muted-foreground text-center">{t.disclaimer.ipNote}</p>
        </div>
      </div>
    </div>
  );
};
